import type React from "react";
import { Sheet, SheetContent } from "../ui/sheet";
import { useHandleNavigate } from "../../utils/utils";

interface AppProps {
	navigatePath: string;
	children: React.ReactNode;
	className?: string;
}

export const Slider: React.FunctionComponent<AppProps> = ({
	navigatePath,
	children,
	className,
}) => {
	const { handleNavigate, open } = useHandleNavigate(navigatePath);

	return (
		<Sheet defaultOpen={open} onOpenChange={handleNavigate}>
			<SheetContent
				className={`flex flex-col justify-between border-border border-l w-full max-w-screen-sm h-full font-bold text-primary overflow-y-scroll ${className}`}
			>
				{children}
			</SheetContent>
		</Sheet>
	);
};
